import { LoadingSkeleton, typography } from '@joor/design-system'
import styled from 'styled-components'

import { Box } from './LegalWidget.ui'

export enum LoadingLegalWidgetTestIds {
  LoadingTermsPreview = 'loading-terms-preview',
}

const LoadingSkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 8px;

  background: var(--color-neutral-000-full);
  ${typography.alpha.primaryActive.body3}
`

const TermsPreview = styled.div`
  position: relative;
  height: 113px;
  overflow: hidden;
  border-radius: 3px 3px 0px 0px;
  & > div {
    position: absolute;
    top: -2px;
    left: 0;
    height: 100%;
    width: 100%;
  }
`

export const LoadingLegalWidget = ({
  fieldsAmount,
}: {
  fieldsAmount: number
}) => (
  <Box>
    <TermsPreview data-testid={LoadingLegalWidgetTestIds.LoadingTermsPreview}>
      <LoadingSkeleton height={113} width="100%" baseColor="#EBEDF0" />
    </TermsPreview>
    <LoadingSkeletonWrapper>
      <LoadingSkeleton count={fieldsAmount} width="50%" />
    </LoadingSkeletonWrapper>
  </Box>
)
